<script setup>
import { computed, defineEmits } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({ has_netflow: false, days_seen: 0, total_observation: 0, last_seen: null })
  },
  rowData: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['navigate'])

const displayText = computed(() => {
  if (!props.data || !props.data.has_netflow || props.data.days_seen === 0) {
    return ''
  }

  const obs = props.data.total_observation.toLocaleString()
  const label = props.data.total_observation === 1 ? 'observation' : 'observations'

  return `${obs} ${label}`
})

const hasData = computed(() => {
  return props.data && props.data.has_netflow && props.data.days_seen > 0
})

function navigateToEventSearch() {
  const ip = props.rowData?.ip || props.rowData?.ips?.[0]?.ip || props.rowData?.ips?.[0]
  if (ip) {
    emit('navigate', ip)
  }
}
</script>

<template>
  <div v-if="hasData" class="d-flex vertically-centered">
    <span>{{ displayText }}</span>
    <span class="netflow-icon ms-auto" @click.stop="navigateToEventSearch">
      <font-awesome-icon style="font-size: 1rem;" :icon="['fas', 'square-up-right']" />
    </span>
  </div>
</template>

<style scoped>
.netflow-icon {
  color: #4b5563;
  cursor: pointer;
}

.netflow-icon:hover {
  color: white;
}
</style>
